import { QUARANTINE_BAIL, START_BONUS } from '../game/engine'
import { useGame } from '../store/gameStore'
import { money } from '../util/format'

export function Rules() {
  const { toggleRules } = useGame()
  return (
    <div className="modal-scrim" onClick={() => toggleRules(false)}>
      <div className="modal rules-modal" onClick={(e) => e.stopPropagation()}>
        <header className="modal-head">
          <span className="modal-emoji">📖</span>
          <span className="modal-kicker">กติกา MILLO</span>
          <h2>เศรษฐีที่ชนะด้วยกระแสเงินสด</h2>
        </header>

        <div className="rules-body">
          <section>
            <h3>🏆 ชนะได้สองทาง</h3>
            <ul>
              <li>
                <b>หลุดพ้นวงจรหนู</b> — ทำ Passive Income (กระแสเงินสดต่อเดือนจากสินทรัพย์ + โฉนด)
                ให้มากกว่าหรือเท่ากับรายจ่ายรวม แล้วชนะทันที
              </li>
              <li>
                <b>ผู้รอดคนสุดท้าย</b> — คู่แข่งล้มละลายหมดกระดาน
              </li>
            </ul>
          </section>

          <section>
            <h3>💵 Payday</h3>
            <p>
              ทุกครั้งที่เดินผ่านช่องจุดเริ่มต้น จะได้รับ{' '}
              <b>เงินเดือน + Passive Income − รายจ่ายประจำ − ค่าผ่อนหนี้</b>
              <br />
              ถ้าลงตรงช่องจุดเริ่มต้นเป๊ะ ๆ จะได้โบนัสเพิ่ม {money(START_BONUS)}
            </p>
          </section>

          <section>
            <h3>🏠 ซื้อโฉนด: สด หรือ ผ่อน?</h3>
            <ul>
              <li>
                <b>ซื้อสด</b> — จ่ายเต็มราคา ได้กระแสเงินสดเต็มจำนวน ไม่มีหนี้
              </li>
              <li>
                <b>ผ่อน (เลเวอเรจ)</b> — ดาวน์ 20% (นักบินอวกาศ 10%) ที่เหลือเป็นสินเชื่อ
                มีค่าผ่อน 1% ของยอดกู้ต่อเดือน ยิ่งผ่อนยิ่งคุมโฉนดได้เยอะ แต่รายจ่ายรวมสูงขึ้น
                ทำให้เป้าหมายหลุดวงจรหนูขยับไกลขึ้น — นี่คือดาบสองคมที่หนังสือของ Kiyosaki พูดถึง
              </li>
              <li>
                ถือครบทุกช่องในกลุ่มสีเดียวกัน → ค่าเช่าคูณสอง และปลดล็อกการอัปเกรด 4 ระดับ
                (ต้องอัปเกรดไล่ระดับให้กระจายกันในกลุ่ม)
              </li>
            </ul>
          </section>

          <section>
            <h3>💡 การ์ด DEAL</h3>
            <p>
              ลงช่อง 💡 เพื่อจั่วโอกาสธุรกิจ — หุ้น, อสังหา, ธุรกิจ, คริปโต
              สินทรัพย์เหล่านี้ปั๊มกระแสเงินสดเข้ามาทุกเดือนโดยไม่ต้องรอให้ใครเหยียบช่อง
              จึงเป็นทางที่เร็วที่สุดสู่การหลุดพ้นวงจรหนู ดูช่อง{' '}
              <b>ผลตอบแทน/เดือน</b> ประกอบการตัดสินใจ (เกิน 1.3% ถือว่าคุ้ม)
            </p>
          </section>

          <section>
            <h3>🛰️ เหตุการณ์ไซไฟ</h3>
            <ul>
              <li>
                <b>🌍 ระดับโลก</b> — พายุสุริยะดันดอกเบี้ย, AI แย่งงานหั่นเงินเดือน 30%,
                ฟองสบู่คริปโตแตก, เอเลี่ยนมาเที่ยวทำค่าเช่าคูณสอง กระทบทุกคนพร้อมกัน
              </li>
              <li>
                <b>🎯 รายตัว</b> — แช่แข็งไครโอ (ข้ามตา), บัญชีถูกแฮก (ห้ามซื้อ),
                สนามแม่เหล็ก (เต๋าตันที่ 3), หลุมดำจิ๋ว (ดูดไปช่องสุ่ม), ไทม์ลูป (ถอย 5 ช่อง)
              </li>
              <li>
                <b>🛡️ โล่พลังงาน</b> — ดูดซับโทษรายตัวได้ 1 ครั้ง นักสืบไซเบอร์เริ่มเกมมีติดตัวเลย
              </li>
            </ul>
          </section>

          <section>
            <h3>🧊 สถานีกักกัน</h3>
            <p>
              ลงช่อง 🚨 หรือทอยแต้มคู่ 3 ครั้งติด = ถูกส่งเข้าสถานีกักกัน 2 ตา
              จ่ายค่าประกันตัว {money(QUARANTINE_BAIL)} เพื่อออกก่อนได้ (ยังเก็บค่าเช่าได้ตามปกติ)
            </p>
          </section>

          <section>
            <h3>🩸 เงินสดติดลบ</h3>
            <p>
              ต้องขายสินทรัพย์ ขายโฉนด (ได้ 50% ของมูลค่า) หรือจำนอง (ได้ 50% ของราคา
              แต่หยุดเก็บค่าเช่าและกระแสเงินสด) จนเงินสดกลับมาไม่ติดลบ
              ถ้าขายทุกอย่างแล้วยังไม่พอ = ล้มละลาย ออกจากเกม
            </p>
          </section>

          <section>
            <h3>🧾 ภาษี &amp; กองกลาง</h3>
            <p>
              ภาษีคิดจากสินทรัพย์รวม (ยิ่งรวยยิ่งจ่ายหนัก) และเงินภาษีทั้งหมดจะกองอยู่ที่
              🏝️ ท่าอวกาศพักผ่อน — ใครไปถึงก่อนเก็บไปทั้งกอง
            </p>
          </section>
        </div>

        <div className="modal-actions">
          <button className="btn btn-primary" onClick={() => toggleRules(false)}>
            ปิด
          </button>
        </div>
      </div>
    </div>
  )
}
